"use strict";

(function () {
  window.addEventListener("brightcoveloaded", function (e) {
    var videos = document.querySelectorAll('.feature_sa .brightcove_player__video');
    var featureLabels = document.querySelectorAll('.feature_sa__label');
    videos && featureLabels && featureLabels.forEach(function (label) {
      return label.addEventListener("click", function () {
        for (var i = 0; i < videos.length; i++) {
          videojs.getPlayer(videos[i].id).pause();
        }
      });
    });
  });
})();